/**
 * Field
 * TODO: Handle invalid
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import Icon from 'ui-component-library/base/Icon';
import { useFieldValidation } from '../hooks/useFieldValidation';
import { useFormValue } from '../context/Form.context';
var Field = function (props) {
    var _a = props.parentClassName, parentClassName = _a === void 0 ? '' : _a, _b = props.className, className = _b === void 0 ? '' : _b, placeholder = props.placeholder, onFieldChange = props.onFieldChange, defaultValue = props.defaultValue, autoSubmit = props.autoSubmit, name = props.name, id = props.id, showError = props.showError, setFocus = props.setFocus, visibleFields = props.visibleFields, noValidate = props.noValidate, type = props.type, label = props.label, describedby = props.describedby, required = props.required, resetForm = props.resetForm, patternMessage = props.patternMessage, validationMessage = props.validationMessage, fieldRef = props.fieldRef, allProps = __rest(props, ["parentClassName", "className", "placeholder", "onFieldChange", "defaultValue", "autoSubmit", "name", "id", "showError", "setFocus", "visibleFields", "noValidate", "type", "label", "describedby", "required", "resetForm", "patternMessage", "validationMessage", "fieldRef"]);
    var _c = useFormValue(), invalidFields = _c[0].invalidFields, dispatch = _c[1];
    var _d = useState(defaultValue || ''), value = _d[0], setValue = _d[1];
    var _e = useState(false), valid = _e[0], setValid = _e[1];
    var _f = useState(false), touched = _f[0], setTouched = _f[1];
    if (!fieldRef) {
        fieldRef = useRef(null);
    }
    var _g = useFieldValidation(fieldRef, props), validateField = _g[0], showFieldError = _g[1], hideFieldError = _g[2];
    useEffect(function () {
        var validatedField = validateField(value);
        var fieldIsValid = !validatedField.message;
        if (validatedField.message) {
            setValid(false);
            dispatch({ type: 'FIELD_INVALID', field: validatedField });
        }
        else {
            setValid(true);
            if (invalidFields.includes(validatedField.id)) {
                dispatch({ type: 'FIELD_VALID', field: validatedField });
            }
        }
        if (!noValidate) {
            if (touched && !fieldIsValid) {
                showFieldError(validatedField);
            }
            else if ((showError &&
                !fieldIsValid &&
                visibleFields &&
                visibleFields.includes(id)) ||
                (showError && !fieldIsValid && !visibleFields)) {
                setTouched(true);
                showFieldError(validatedField);
            }
            else {
                hideFieldError();
            }
            if (setFocus) {
                fieldRef.current.focus();
            }
        }
    }, [touched, showError, value, setFocus, visibleFields, required]);
    useEffect(function () {
        var tmpValue = defaultValue || '';
        setValue(tmpValue);
        // update form.context with latest value
        onChange(tmpValue.toString());
    }, [defaultValue]);
    useEffect(function () {
        var _a;
        if (document.hasFocus() && (fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) === document.activeElement) {
            (_a = fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, []);
    var onChange = function (e) {
        var newValue = '';
        if (typeof e === 'string') {
            newValue = e;
        }
        else {
            var target = e.target;
            newValue = target.value;
        }
        setValue(newValue);
        onFieldChange({
            name: name,
            value: newValue,
            type: 'Field',
            autoSubmit: autoSubmit,
        });
    };
    var describedByAttribute = "form" + id + "__desc" + (describedby ? " " + describedby : '');
    return (React.createElement("div", { className: clsx('relative', parentClassName) },
        React.createElement("input", __assign({ className: clsx(className, 'text-p', 'leading-4', 'h-10', 'w-full', 'px-3', 'py-1', 'border-2', !valid && touched
                ? 'border-red'
                : 'border-greySemiLight focus:border-blue', 'rounded', 'transition-all', 'focus:outline-none', 'disabled:text-greyLight', 'disabled:cursor-not-allowed', 'placeholder-greyDarker', 'placeholder-opacity-100', type === 'file' && 'pt-2'), placeholder: placeholder || '', "aria-invalid": !valid, value: value, name: name, required: required, onChange: onChange, onBlur: function () { return setTouched(true); }, ref: fieldRef, id: id, "aria-describedby": !noValidate ? describedByAttribute : undefined, type: type === null ? 'text' : type }, allProps)),
        value && (React.createElement("button", { className: "absolute top-0 right-0 flex items-center h-full p-2 text-greyDarker hover:text-greyDarker-hover", type: "button", onClick: function () {
                var _a;
                onChange('');
                (_a = fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            } },
            React.createElement("span", { className: "sr-only" }, "Rensa"),
            React.createElement(Icon, { icon: "clear", size: 1, "aria-hidden": true, className: "fill-current" })))));
};
export default Field;
